import { useEffect, useMemo, useState } from "react";
import {
  BucketAttachment,
  BucketImage,
  OnboardingTimelineGallery,
} from "../../../graphql/models";
import { i18nForFields } from "../../../i18n";
import {
  Button,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { I18NTextField } from "../i18n_text_field";
import { ImageEntry, ImagePicker, ImagePickerType } from "../image-picker";
import { OnboardingTimelineGalleryRow } from "./onboarding_timeline_gallery_row";
import { I18NMarkdownEditor } from "../i18n_markdown_editor";
import { AttachmentsPicker } from "../attachments-picker";

export interface OnboardingTimelineGalleryComponentProps {
  gallery?: OnboardingTimelineGallery;
  onChange: (gallery: OnboardingTimelineGallery) => void;
}

export interface OnboardingGalleryPhotoItem {
  photo: BucketImage;
  index: number;
}

export interface OnboardingGalleryDocItem {
  doc: BucketAttachment;
  index: number;
}

export function OnboardingTimelineGalleryComponent(
  props: OnboardingTimelineGalleryComponentProps
) {
  const { gallery } = props;
  //const photos = gallery?.photos;
  const [i18nFields, setI18nFields] = useState<
    Partial<i18nForFields<"title" | "description">>
  >(gallery?.i18n ?? {});
  const [photos, setPhotos] = useState(
    gallery?.photos
      ? gallery.photos.map((p, index) => {
          const v: OnboardingGalleryPhotoItem = {
            photo: p,
            index: (index + 1) * 10,
          };
          return v;
        })
      : []
  );
  // const docsInitState = useMemo(() => {
  //   if (gallery?.docs) {
  //     return gallery.docs.map((item) => {
  //       const o: AttachmentWithTitleItem = {
  //         file: item,
  //         i18n: {
  //           title_it: item.name,
  //         },
  //       };
  //       return o;
  //     });
  //   } else return [];
  // }, []);
  const [docs, setDocs] = useState(gallery?.attachments || []);
  const [mode, setMode] = useState("image");
  const showImages = useMemo(() => "image" === mode, [mode]);

  const orders = photos.map((item) => item.index);
  const maxOrderValue = photos.length === 0 ? 10 : Math.max(...orders);

  /*
  let items: OnboardingGalleryPhotoItem[] = [];
  console.log(`calc items`);
  if (photos)
    items = photos.map((photo: BucketImage, index) => {
      return {
        photo: photo,
        index: (index + 1) * 10,
      };
    });
*/
  const onUploadedHandler = (image: ImageEntry) => {
    const p: BucketImage = {
      url: image.url,
    };
    const newItem: OnboardingGalleryPhotoItem = {
      photo: p,
      index: maxOrderValue + 10,
    };
    const newPhotos = [...photos, newItem];
    setPhotos(newPhotos);
    // const array = photos ? [...photos, p] : [p];
    //props.onChange(buildObject(array));
  };

  useEffect(() => {
    const g: OnboardingTimelineGallery = {
      title: i18nFields?.title_it ?? "",
      description: i18nFields?.description_it ?? "",
      photos: photos.map((item) => item.photo),
      attachments: docs,
      i18n: i18nFields,
    };
    props.onChange(g);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [photos, i18nFields, docs]);

  // const buildObject = (array: BucketImage[]) => {
  //   const g: OnboardingTimelineGallery = {
  //     title: i18nFields?.title_it ?? "",
  //     description: i18nFields?.description_it ?? "",
  //     photos: array,
  //     i18n: i18nFields,
  //   };
  //   return g;
  // };

  const onReorderHandler = () => {
    const array = [...photos];
    const sortedArray = array.sort((a, b) => a.index - b.index);
    setPhotos(sortedArray);
    // const mappedArray = sortedArray.map((item) => {
    //   return {
    //     url: item.photo.url,
    //   };
    // });
    // props.onChange(buildObject(mappedArray));
  };

  const onOrderItemChanges = (
    item: OnboardingGalleryPhotoItem,
    index: number
  ) => {
    const array = [...photos];
    array[index] = item;
    setPhotos(array);
    // props.onChange(buildObject(array.map((e) => toBucketImage(e))));
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <h5>Galleria collegata a questa riga</h5>
      </Grid>
      <Grid item xs={12} md={6} lg={6}>
        <I18NTextField
          label="Titolo della galleria"
          variant="outlined"
          value={i18nFields}
          i18nFieldName="title"
          onChange={setI18nFields}
          style={{ width: "100%" }}
        />
      </Grid>
      <Grid item xs={12}>
        <p>Inserisci la descrizione per la galleria</p>
        <I18NMarkdownEditor
          i18nFieldName="description"
          value={i18nFields}
          onChange={setI18nFields}
        ></I18NMarkdownEditor>
      </Grid>
      <Grid item xs={12}>
        <FormLabel>Tipo di contenuto</FormLabel>
        <RadioGroup
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          defaultValue={mode}
          onChange={(e) => setMode(e.target.value)}
        >
          <FormControlLabel
            value="image"
            control={<Radio />}
            label="Immagini"
          />
          <FormControlLabel value="doc" control={<Radio />} label="Documenti" />
        </RadioGroup>
      </Grid>
      {showImages &&
        photos.map((item, index) => {
          return (
            <OnboardingTimelineGalleryRow
              key={item.photo.url}
              item={item}
              onChange={(v) => onOrderItemChanges(v, index)}
            />
          );
        })}
      {!showImages && (
        <AttachmentsPicker
          title="Documenti"
          defaultValue={docs}
          onUpdated={setDocs}
        />
      )}
      <Grid item xs={12}>
        <ImagePicker
          onUploaded={onUploadedHandler}
          type={ImagePickerType.Simple}
        ></ImagePicker>
        {photos.length > 1 && (
          <Button variant="outlined" onClick={onReorderHandler}>
            Applica ordinamento
          </Button>
        )}
      </Grid>
    </Grid>
  );
}
